var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlue01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#264D61;stroke-width:65.13;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_843",
    className: "st0",
    d: "M162.9,442.1L349,256L162.9,69.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue01);
export default __webpack_public_path__ + "static/media/arrow_blue-01.96d503d33e3ec34c81aa5dc888b32927.svg";
export { ForwardRef as ReactComponent };